import { Form } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import '../../theming/themes.js';
import React, { memo, createContext, useContext } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _Heading from '../Heading/index.js';
import _Button from '../Button/index.js';
import _Loader from '../Loader/index.js';
import { Modal as Modal$1 } from '@mantine/core';

var _excluded = ["title", "children", "opened", "submitButtonText", "submitButtonProps", "cancelButtonText", "cancelButtonProps", "cancelButton", "submitButton", "theme", "language", "onClose", "onSubmit", "isSubmitting", "isForm", "size", "formProps", "closeButtonProps"];
var _templateObject;
var ModalContext = /*#__PURE__*/createContext(undefined);
var Language;
(function (Language) {
  Language["ENGLISH"] = "en";
  Language["SPANISH"] = "es";
})(Language || (Language = {}));
var StyledModalFooter = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-end;\n  "])));
var ModalFooter = /*#__PURE__*/memo(function () {
  var _ref = useContext(ModalContext) || {},
    cancelButton = _ref.cancelButton,
    onClose = _ref.onClose,
    cancelButtonProps = _ref.cancelButtonProps,
    cancelButtonText = _ref.cancelButtonText,
    language = _ref.language,
    submitButton = _ref.submitButton,
    isForm = _ref.isForm,
    onSubmit = _ref.onSubmit,
    submitButtonProps = _ref.submitButtonProps,
    submitButtonText = _ref.submitButtonText;
  return /*#__PURE__*/React.createElement(StyledModalFooter, null, cancelButton && /*#__PURE__*/React.createElement(_Button, _extends({
    onClick: onClose,
    buttonType: "text",
    type: "button"
  }, cancelButtonProps), cancelButtonText ? cancelButtonText : language === Language.ENGLISH ? 'Cancel' : 'Cancelar'), submitButton && /*#__PURE__*/React.createElement(_Button, _extends({
    type: isForm ? 'submit' : 'button',
    onClick: function onClick() {
      !isForm && onSubmit && onSubmit();
    },
    buttonType: "primary"
  }, submitButtonProps), submitButtonText ? submitButtonText : language === Language.ENGLISH ? 'Okay' : 'Confirmar'));
});
var Modal = function Modal(_ref2) {
  var title = _ref2.title,
    children = _ref2.children,
    opened = _ref2.opened,
    submitButtonText = _ref2.submitButtonText,
    submitButtonProps = _ref2.submitButtonProps,
    cancelButtonText = _ref2.cancelButtonText,
    cancelButtonProps = _ref2.cancelButtonProps,
    _ref2$cancelButton = _ref2.cancelButton,
    cancelButton = _ref2$cancelButton === void 0 ? true : _ref2$cancelButton,
    _ref2$submitButton = _ref2.submitButton,
    submitButton = _ref2$submitButton === void 0 ? true : _ref2$submitButton,
    _ref2$theme = _ref2.theme,
    _ref2$language = _ref2.language,
    language = _ref2$language === void 0 ? Language.ENGLISH : _ref2$language,
    onClose = _ref2.onClose,
    _onSubmit = _ref2.onSubmit,
    _ref2$isSubmitting = _ref2.isSubmitting,
    isSubmitting = _ref2$isSubmitting === void 0 ? false : _ref2$isSubmitting,
    _ref2$isForm = _ref2.isForm,
    isForm = _ref2$isForm === void 0 ? false : _ref2$isForm,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'lg' : _ref2$size,
    formProps = _ref2.formProps,
    closeButtonProps = _ref2.closeButtonProps,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var modalFooterProps = {
    title: title,
    opened: opened,
    cancelButton: cancelButton,
    onClose: onClose,
    cancelButtonProps: cancelButtonProps,
    cancelButtonText: cancelButtonText,
    language: language,
    submitButton: submitButton,
    isForm: isForm,
    onSubmit: _onSubmit,
    submitButtonProps: submitButtonProps,
    submitButtonText: submitButtonText,
    formProps: formProps
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal$1, _extends({
    size: size,
    opened: opened,
    title: typeof title === 'string' ? /*#__PURE__*/React.createElement(_Heading, {
      elemType: 'h2',
      color: 'primary'
    }, title) : title,
    closeButtonProps: _objectSpread2({
      icon: /*#__PURE__*/React.createElement(_Icon, {
        name: 'close-thin'
      }),
      'aria-label': 'Close modal button'
    }, closeButtonProps),
    onClose: onClose,
    styles: {
      content: {
        padding: '2.8125rem',
        paddingBottom: '1rem'
      }
    }
  }, rest), /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: modalFooterProps
  }, isForm ? /*#__PURE__*/React.createElement(_Loader, {
    isShown: isSubmitting
  }, /*#__PURE__*/React.createElement(Form, _extends({
    onSubmit: function onSubmit(values) {
      return _onSubmit && _onSubmit(values);
    }
  }, formProps), children, /*#__PURE__*/React.createElement(ModalFooter, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(ModalFooter, null)))));
};
var _NewModal = withDefaultTheme(/*#__PURE__*/memo(Modal));

export default _NewModal;
export { Language, Modal };
